import { Pipe, PipeTransform } from '@angular/core';
import { CartService } from 'src/app/services/api/cart.service';
import { roundNumber } from '../common';

@Pipe({
  name: 'money'
})
export class MoneyPipe implements PipeTransform {

	constructor(
		// private cartService : CartService
	){

	}

	transform(value = '0', currency: any = null): any {

		// if(!currency){
		//   currency = 'PHP';
		// }
		// // if you want two decimal
		// let nf = new Intl.NumberFormat('tl-PH', { style: 'currency', currency: currency });
		// /* let nf = new Intl.NumberFormat(); */

		let amount = roundNumber(parseFloat(value));
		// return nf.format(amount);

		// return "₱" + amount;

		let formatted = amount.toLocaleString('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});

		return "₱" + formatted;
	}

}
